module.exports = "/_next/static/images/popup-bg-start-32594a1e.png";